import React from 'react';
import { processMarkup } from "./core/ProcessMarkup";

//Handle bots
const isCrawler = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

processMarkup();